export const idx_data_clt = [];

idx_data_clt.push({
  angle: '',
  f1_lat: '',
  f2_lat: '',
});

idx_data_clt.push({
  angle: 'A - 8',
  f1_lat: '3/8',
  f2_lat: '1/2',
});

idx_data_clt.push({
  angle: 'B - 16',
  f1_lat: '5/16',
  f2_lat: '9/16',
});

idx_data_clt.push({
  angle: 'C - 24',
  f1_lat: '1/4',
  f2_lat: '5/8',
});

idx_data_clt.push({
  angle: 'D - 32',
  f1_lat: '3/16',
  f2_lat: '11/16',
});

idx_data_clt.push({
  angle: 'E - 40',
  f1_lat: '1/8',
  f2_lat: '3/4',
});
